module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'menu' && templateVars.config ?
				templateVars.config :
				{
	"menuDisableBreakpoint": 768
};